import { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';

type Props = {
  isOpen: boolean;
  message: string;
  variant?: 'success' | 'error';
  topMost?: boolean;
  action?: Function;
};

export const Alert = ({
  isOpen,
  message,
  variant = 'error',
  topMost = false,
  action,
}: Props) => {
  const classes = classNames(
    'fixed z-20 top-5 left-1/2 transform -translate-x-1/2 max-w-sm w-full shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden',
    {
      'bg-rose-500 text-white': variant === 'error',
      'bg-blue-500 text-white': variant === 'success',
    }
  );

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="ease-out duration-300 transition"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className={classes}>
        <div className="p-4 text-center">
          <p className="text-sm font-medium">{message}</p>

          {action && (
            <button
              type="button"
              className="mt-2 rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
              onClick={() => {
                action();
              }}
            >
              Retry
            </button>
          )}
        </div>
      </div>
    </Transition>
  );
};
